import { TFunction } from "i18next";
import * as Yup from "yup";

const normalizeTitle = (value?: string) => (value ?? "").trim().toLowerCase();

export const getImprovementPlanActionFormSchema = (t: TFunction, existingActionTitles: string[] = []) => {
    const normalizedExistingTitles = new Set(existingActionTitles.map((title) => normalizeTitle(title)).filter(Boolean));

    return Yup.object().shape({
        description: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm"))
            .test(
                "unique-action-title",
                t("improvementPlan:actionForm.errors.duplicateTitle"),
                (value) => !normalizedExistingTitles.has(normalizeTitle(value))
            ),
        comments: Yup.array()
            .of(
                Yup.object().shape({
                    comment: Yup.string()
                        .trim()
                        .required(t("common:form.requiredFieldForm")),
                })
            )
            .nullable()
            .notRequired(),
        // claimType: Yup.number()
        //     .required(t("common:form.requiredFieldForm"))
        //     .min(0, t("common:form.requiredFieldForm")),
        status: Yup.number()
            .required(t("common:form.requiredFieldForm"))
            .min(0, t("common:form.requiredFieldForm")),
        responsibleId: Yup.number()
            .nullable()
            .notRequired(),
        actionTypeId: Yup.number()
            .nullable()
            .notRequired(),
        startDate: Yup.date()
            .nullable()
            .notRequired(),
        endDate: Yup.date()
            .nullable()
            .when("startDate", ([startDate], schema) =>
                startDate
                    ? schema.test(
                        "endDate-after-startDate",
                        t("common:form.messageErrorFinishDateBeforeStartDate"),
                        (endDate) => {
                            if (!endDate) return true;
                            return endDate.getTime() > startDate.getTime();
                        }
                    )
                    : schema
            )
            .notRequired(),
    });
};
